import PropTypes from 'prop-types';
import styles from './Glossary.module.scss';
import GlossaryList from './GlossaryList';

export const Glossary = ({ sections }) => (
	<>
		{sections?.map((elem, key) => (
			<div key={key} className={styles.section} id={elem.letter} data-test-id="glossary-container">
				<h2>{elem.letter}</h2>
				<GlossaryList sublist={elem.list} />
			</div>
		))}
	</>
);

Glossary.propTypes = {
	sections: PropTypes.array.isRequired,
};

export default Glossary;
